<app-legals-footer-block [config]="{ 'links': links }"></app-legals-footer-block>
